/* 学习目标页面 */

/*
TODO: 第二周计划
TODO: 用户数据连接
*/
<template>
<div>
  <div class="main-title title flex-row flex-center" style='color:white'>猩球启蒙计划 第{{week}}周 学习目标</div>
  <!-- 家长目标 -->
  <parent-target :parent_target="parent_target" v-if="!isEmptyObject(parent_target)"></parent-target>

  <!-- 学员目标 -->
  <student-target :stu_target="stu_target" v-if="!isEmptyObject(stu_target)"></student-target>

  <div class='flex-row flex-center'>
  <a href="/feedback"><button class='feedback'>本周学习反馈</button></a>
  </div>

  <div class='flex-row flex-center' v-if="feedbackID != null">
    <a :href="'/feedback/' + feedbackID"><button class='feedback'>{{feedbackName}}</button></a>
  </div>

</div>
</template>

<script>
require('@/assets/css/common-flex.css')
require('@/assets/css/target.css')
require('@/assets/css/feedback.css')
import BaseVue from '@/components/BaseVue'
import ParentTarget from '@/components/template/target/ParentTarget'
import StudentTarget from '@/components/template/target/StudentTarget'

export default {
  name: 'Target',
  extends: BaseVue,
  components: {ParentTarget, StudentTarget},
  data () {
    return {
      stu_target: {},
      parent_target: {
        reading_desc: '<p>本周少儿英语猩球启蒙计划的第一周，<strong>孩子生来就是让父母长大的</strong>！宝爸宝妈们，您们准备好了吗？万事开头难，尤其是理论，在英语启蒙道路上"长大"，首先得保证咱们脑中有科学启蒙理论来武装自己，才不会被各个机构或者课程顾问说的团团转哟！熟知启蒙路上科学启蒙理论，才能做到<strong style="color: orange">道术兼并，知行合一，心中有目标，脚下有路线，手中有资源</strong>，让孩子们再也不走我们的“哑巴英语”道路啦！Go！</p> <p>第一周宝爸宝妈们需要学习三篇英文启蒙相关理论，<strong>每篇文章阅读时长在15-20分左右</strong>，每篇文章可以选择在一个晚上一个集中的时间阅读哟，只要在本周看完即可啦！做到心中有数，如果有什么疑问也欢迎咨询我们公众号！以下是本周资源：</p>',
        parentArticle_content: [
          {'id': 1, 'title': '99%的妈妈都不知道的少儿英语启蒙', link: '/resource/parent/1'},
          {'id': 2, 'title': '父母英语水平差，还可以亲子阅读吗？', link: '/resource/parent/2'},
          {'id': 3, 'title': '终于，专家研究发现了孩子学英语的关键期！', link: '/resource/parent/3'}
        ]
      },
      week: 1,
      feedbackName: '',
      feedbackID: null
    }
  },
  created: function () {
    let data_id = this.$route.params.id
    if (data_id === undefined) return
    this.week = data_id;
    let url = this.APIHOST + 'newtarget?id=' + data_id + '?format=json'
    let that = this;
    this.queryData(url, function (data) {
      that.stu_target = data.stu_target
      that.parent_target = data.parent_target
      that.getFeedBack()
    })
  },
  methods: {
    hasFeedback: function (book) {
      if (book.feedback === undefined) return false
      return book.feedback
    },
    getFeedBack: function () {
      let books = this.stu_target.book_content
      if (books === undefined) return false
      for (let i = 0; i < books.length ;i++){
        let book = books[i]
        if (this.hasFeedback(book)) {
          this.feedbackName = book.title + '学习反馈'
          this.feedbackID = book.id
          return true
        }
      }
      return false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Target.vue